import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {UploadDokumenRoutingModule} from "./upload-dokumen-routing.module";
import {GlobalModule} from "../global/global.module";
import {AngularSignaturePadModule} from "@almothafar/angular-signature-pad";
import {UploadDokumenComponent} from "./upload-dokumen.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    UploadDokumenRoutingModule,
    GlobalModule,
    AngularSignaturePadModule,
  ],
  declarations: [
    UploadDokumenComponent
  ]
})
export class UploadDokumenModule {

}
